<template>
  <div class="container my-4">

    <div class="heading" role="alert">
      <h4><i class="bi bi-people-fill biside"></i> Student List</h4>
    </div>

    <!-- Filter Bar -->
     <div class="mb-4 d-flex flex-column flex-sm-row align-items-start gap-2">
      <!-- Institute Dropdown -->
      <select v-model="selectedInstitute" class="form-select">
        <option value="">All Institutes</option>
        <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
          {{ institute.institute_name }}
        </option>
      </select>

      <!-- Subject Dropdown -->
      <select v-model="selectedSubject" class="form-select">
        <option value="">All Subjects</option>
        <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
          {{ subject.name }}
        </option>
      </select>

      <!-- Grade Dropdown -->
      <select v-model="selectedGrade" class="form-select">
        <option value="">All Grades</option>
        <option v-for="grade in grades" :key="grade.id" :value="grade.id">
          Grade {{ grade.grade_level }}
        </option>
      </select>
    </div>
    
    <input
    v-model="searchQuery"
    type="text"
    class="form-control my-3"
    placeholder="Search by student name..."
    >

    <div class="mb-2">
      <span class="badge text-bg-primary">
  <strong>Total Students:</strong> {{ totalAll }} |
  <strong>Filtered:</strong> {{ totalFiltered }}
  </span>
</div>



    <!-- Loading Spinner -->
    <div v-if="loading" class="text-center my-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Student Table -->
    <div v-if="!loading" class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Grade</th>
            <th>Subject</th>
            <th>Institute</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="student in students" :key="student.id">
            <td>{{ student.id }}</td>
            <td>{{ student.first_name }} {{ student.last_name }}</td>
            <td>{{ student.grade?.grade_level || 'N/A' }}</td>
            <td>{{ student.subject?.name || 'N/A' }}</td>
            <td>{{ student.institute?.institute_name || 'N/A' }}</td>
            <td>
              <button
                class="btn btn-outline-primary btn-sm"
                data-bs-toggle="modal"
                :data-bs-target="'#showProfileModal' + student.id"
              >
                <i class="bi bi-eye"></i> View
              </button>
            </td>
          </tr>
          <tr v-if="students.length === 0 && (searchQuery || selectedSubject || selectedGrade || selectedInstitute)">
  <td colspan="7" class="text-center text-danger">No students available.</td>
</tr>

        </tbody>
      </table>

      <nav v-if="totalPages > 1" class="d-flex justify-content-center mt-3">
  <ul class="pagination">
    <li class="page-item" :class="{ disabled: currentPage === 1 }">
      <a class="page-link" @click.prevent="changePage(currentPage - 1)" href="#">Previous</a>
    </li>

    <li
      class="page-item"
      v-for="page in totalPages"
      :key="page"
      :class="{ active: currentPage === page }"
    >
      <a class="page-link" @click.prevent="changePage(page)" href="#">{{ page }}</a>
    </li>

    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
      <a class="page-link" @click.prevent="changePage(currentPage + 1)" href="#">Next</a>
    </li>
  </ul>
</nav>

    </div>

    <!-- Modals -->
    <div
      v-for="student in students"
      :key="'modal-' + student.id"
      class="modal fade"
      :id="'showProfileModal' + student.id"
      tabindex="-1"
      :aria-labelledby="'showProfileModalLabel' + student.id"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="'showProfileModalLabel' + student.id">
              {{ student.first_name }} {{ student.last_name }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p><strong>Name:</strong> {{ student.first_name }} {{ student.last_name }}</p>
            <p><strong>Grade:</strong> {{ student.grade?.grade_level || 'N/A' }}</p>
            <p><strong>Subject:</strong> {{ student.subject?.name || 'N/A' }}</p>
            <p><strong>Institute:</strong> {{ student.institute?.institute_name || 'N/A' }}</p>
            <p><strong>Payment Status:</strong> {{ student.student_item?.status || 'N/A' }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      selectedSubject: "",
      selectedGrade: "",
      selectedInstitute: "",
      searchQuery: "",
      subjects: [],
      grades: [],
      institutes: [],
      students: [],
      loading: false,
      currentPage: 1,
totalPages: 0,
totalFiltered: 0,
totalAll: 0,


    };
  },
  methods: {
    async fetchGrades() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-grade", {
          teacher_id: teacherId,
        });
        this.grades = response.data;
      } catch (error) {
        console.error("Failed to fetch grades:", error);
      }
    },
    async fetchSubjects() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-subjects", {
          teacher_id: teacherId,
        });
        this.subjects = response.data;
      } catch (error) {
        console.error("Failed to fetch subjects:", error);
      }
    },
    async fetchInstitutes() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-institutes", {
          teacher_id: teacherId,
        });
        this.institutes = response.data;
      } catch (error) {
        console.error("Failed to fetch institutes:", error);
      }
    },
    async fetchStudents() {
  const teacherId = localStorage.getItem("teacher_id");
  const token = localStorage.getItem("token");
  this.loading = true;
  try {
    const response = await axios.post(
      `/get-students-by-teacher?page=${this.currentPage}`,
      {
        teacher_id: teacherId,
        subject_id: this.selectedSubject,
        grade_id: this.selectedGrade,
        institute_id: this.selectedInstitute,
        search_query: this.searchQuery,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    this.students = response.data.data;
    this.totalPages = response.data.last_page;
    this.totalFiltered = response.data.total_filtered;  // ✅
    this.totalAll = response.data.total_all;            // ✅
  } catch (error) {
    console.error("Error fetching students:", error);
  } finally {
    this.loading = false;
  }
},

changePage(page) {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
    this.fetchStudents();
  }
},
  },
  watch: {
    selectedSubject: "fetchStudents",
    selectedGrade: "fetchStudents",
    selectedInstitute: "fetchStudents",
    searchQuery: {
    handler: "fetchStudents",
    immediate: false
  },
  },
  mounted() {
    this.fetchInstitutes();
    this.fetchGrades();
    this.fetchSubjects();
    this.fetchStudents();
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
.modal-dialog {
  max-width: 100%;
}

.heading{
    background-color: rgb(95, 95, 241);
    border: 2px solid #007bff;
    border-radius: 5px;
    padding: 10px;
    color: white;
    margin-bottom: 5dvh;
  }
@media (max-width: 768px) {
  .table th,
  .table td {
    font-size: 0.875rem;
  }

  .table-responsive {
  max-width: 320px;
}
}
</style>